export default {
  NEW_QUOTE: "new quote",
  QUOTE_ACCEPTED: "quote accepted",
  QUOTE_REFUSED: "quote refused",
}